import * as React from 'react';
import { useEagerConnect } from 'hooks';

import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import { Dashboard, PoolSelection } from 'pages';
import { Navbar } from 'components';

const DApp: React.ComponentType = () => {
	useEagerConnect();

	return (
		<Router>
			<div>
				<Navbar />

				<Switch>
					<Route path="/main">
						<Dashboard />
					</Route>

					<Route path="/">
						<PoolSelection />
					</Route>
				</Switch>
			</div>
		</Router>
	);
};

export default DApp;
